// extracted by mini-css-extract-plugin
export var container = "_rv-0";
export var dotAnimation = "_rv-2";
export var dotsLoading = "_rv-1";